/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-computed-property-dependencies, ember/require-tagless-components */
import Component from '@ember/component';
import { computed } from '@ember/object';
import { classNames } from '@ember-decorators/component';

/**
 * Log Card provides a presentation component that provides an information sink
 * based on the concepts of logging levels.
 */
@classNames('log-card', 'constrain-xs')
export default class LogCard extends Component {
  // Props
  // icon provides the icon to display in the title as a visual cue for the
  // user.
  icon = 'info';

  // title provides the title of the message being logged.
  title = 'Info';

  // info specifies the presented message is at an informational level.
  info = false;

  // warn specifies the presented message is at a warning level.
  warn = false;

  // error specifies the presented message is at an error level.
  error = false;

  // Methods
  /**
   * classModifier checks to see if the card should have a modifier applied.
   */
  @computed('info,warn,error')
  get classModifier() {
    let modifier = '';
    switch (true) {
      case this.info:
        modifier = '--info';
        break;

      case this.error:
        modifier = '--error';
        break;

      case this.warn:
        modifier = '--warn';
        break;
    }

    return `log-card__card${modifier}`;
  }
}
